import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { defaultData as BadgeDefaultData } from "@circle-react-shared/BuilderUI/DefaultBlocks/Content/BadgeBlock/BadgeBlockDefaultData";
import type { StyleValue } from "../../../StyleValue.types";

const createBadge = ({
  text,
  styles,
}: {
  text: string;
  styles?: Record<string, StyleValue>;
}): BaseBlock => ({
  ...BadgeDefaultData,
  id: uuidv4(),
  props: {
    ...BadgeDefaultData.props,
    text: {
      ...BadgeDefaultData.props.text,
      prop: "other",
      value: text,
    },
    styles: {
      ...BadgeDefaultData.props.styles,
      prop: "styles",
      type: "styles",
      value: {
        ...(BadgeDefaultData.props.styles.value as Record<string, StyleValue>),
        ...styles,
      },
    },
  },
});

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "badgeList",
  props: {
    content: {
      prop: "children",
      type: "children",
      value: [
        createBadge({
          text: "Badge 1",
        }),
        createBadge({
          text: "Badge 2",
        }),
        createBadge({
          text: "Badge 3",
        }),
      ],
    },
  },
};
